module.exports = __webpack_public_path__ + "img/vibez_potheadz.gm.b47e4e2.png";